import i18n from '@/i18n/i18n';

export type AccountOverviewChartDataProps = {
  labels: string[];
  datasets: [
    {
      label: string;
      backgroundColor: string[];
    },
  ];
};

export const AccountOverviewChartData: AccountOverviewChartDataProps = {
  labels: [
    i18n.t('HomePage.AccountOverviewWidget.ActiveTab.Chart.pendingLabel', { defaultValue: 'Pending' }),
    i18n.t('HomePage.AccountOverviewWidget.ActiveTab.Chart.progressLabel', { defaultValue: 'Progress' }),
    i18n.t('HomePage.AccountOverviewWidget.ActiveTab.Chart.completeLabel', { defaultValue: 'Complete' }),
  ],
  datasets: [
    {
      label: i18n.t('HomePage.AccountOverviewWidget.ActiveTab.Chart.label', { defaultValue: 'Accounts Overview' }),
      backgroundColor: ['#EBEDEF', '#C4C4C4', '#28BE9A'],
    },
  ],
};

export const periodOptions: { [key: string]: string } = {
  Mo: i18n.t('HomePage.AccountOverviewWidget.ActiveTab.PeriodOptions.monthly', { defaultValue: 'Monthly' }),
  Ye: i18n.t('HomePage.AccountOverviewWidget.ActiveTab.PeriodOptions.yearly', { defaultValue: 'Yearly' }),
  We: i18n.t('HomePage.AccountOverviewWidget.ActiveTab.PeriodOptions.weekly', { defaultValue: 'Weekly' }),
};

export const transactionOptions: { [key: string]: string } = {
  Num: i18n.t('HomePage.AccountOverviewWidget.ActiveTab.TransactionOptions.total', {
    defaultValue: 'Total Amount of Transactions',
  }),
  Vol: i18n.t('HomePage.AccountOverviewWidget.ActiveTab.TransactionOptions.volume', {
    defaultValue: 'Volume of Transactions',
  }),
};
